import { GroupingsService } from '../../../_services/groupings.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscription-grouping-quiz-list',
  templateUrl: './subscription-grouping-quiz-list.component.html',
  styleUrls: ['./subscription-grouping-quiz-list.component.css']
})
export class SubscriptionGroupingQuizListComponent implements OnInit {
  quizList:Object=undefined
  subscriptionGrouping:Object = undefined
  server_subscription_grouping_id:number=undefined
  loading=false
  dtOptions: DataTables.Settings = {}

  constructor(private groupingService:GroupingsService) { }
  ngOnInit(): void {
    this.loading=true
    this.subscriptionGrouping=this.groupingService.subscriptionGrouping
    this.server_subscription_grouping_id=this.subscriptionGrouping['server_subscription_grouping_id']
    this.loadQuizList()


  }

  loadQuizList(){
    let quiz_mode_name ="standard"
    this.groupingService.getWebPendingQuiz(this.server_subscription_grouping_id,quiz_mode_name).subscribe(
      values=>{
           this.quizList=values
           this.loading=false
      }
    )
  }
}
